import { noop, type Unsubscribe } from '@amazon/vinyl-util'
import type { PlayLocalDeps } from '@/localFiles/playLocal'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('installDropToPlay')

/**
 * Where the computer's own files play, plays the files dropped on the window (`DropToPlay`);
 * elsewhere, and on a native build without local files, nothing.
 */
export function installDropToPlay(deps: PlayLocalDeps): Unsubscribe {
    const lifetime = new AbortController()
    const disposed = () => lifetime.signal.aborted
    let release: Unsubscribe = noop
    ;(async () => {
        // Loaded lazily, so the boot chunk gains nothing where files never drop.
        const [{ awaitAccountScope }, { localFilesSupported }] = await Promise.all([
            import('@/auth/accountScope'),
            import('@/localFiles/localFilesSupported'),
        ])
        await awaitAccountScope()
        if (!(await localFilesSupported()) || disposed()) return
        const { listenForDrops } = await import('@/localFiles/DropToPlay')
        if (disposed()) return
        release = await listenForDrops(deps)
        if (disposed()) release()
    })().catch(errorHandler)
    return () => {
        lifetime.abort()
        release()
    }
}
